// middleware action creators
import * as ContractIAImportStore from '../../../redux/middleware/ContractIAImportMiddleware';

// state
import { AppState } from '../../../redux/reducers';
import {
	ContractIAImportProcess,
	ImportFeedbackRatingScaleItem,
} from '../../../models/Entities/Contracts/ContractIAImportProcess';
import { ErrorType } from '../../../models/HttpError';

//#region Props

export interface IProps {
	// Proceso a calificar. Sólo los procesos en estado terminal (finalizado,
	// fallido o cancelado) admiten feedback.
	process: ContractIAImportProcess | null;
}

interface ConnectedProps {
	ratingScale: ImportFeedbackRatingScaleItem[];
	isGettingRatingScale: boolean;
	failOnGettingRatingScale: boolean;

	isRating: boolean;
	successRating: boolean | undefined;
	failureRating: boolean;
	ratingError: ErrorType | undefined;
}

interface DispatchProps {
	RateImportContractProcess: typeof ContractIAImportStore.actionCreators.RateImportContractProcess;
	GetImportFeedbackRatingScale: typeof ContractIAImportStore.actionCreators.GetImportFeedbackRatingScale;
}

export type Props = IProps & ConnectedProps & DispatchProps;

//#endregion Props

export const mapStateToProps = (state: AppState) =>
	({
		ratingScale: state.ContractIAImport?.ratingScale ?? [],
		isGettingRatingScale: state.ContractIAImport?.isGettingRatingScale || false,
		failOnGettingRatingScale: state.ContractIAImport?.failOnGettingRatingScale || false,

		isRating: state.ContractIAImport?.isRatingProcess || false,
		successRating: state.ContractIAImport?.successRatingProcess,
		failureRating: state.ContractIAImport?.failOnRatingProcess || false,
		ratingError: state.ContractIAImport?.ratingError,
	} as ConnectedProps);

export const mapDispatchToProps = {
	RateImportContractProcess: ContractIAImportStore.actionCreators.RateImportContractProcess,
	GetImportFeedbackRatingScale: ContractIAImportStore.actionCreators.GetImportFeedbackRatingScale,
};

// Sólo los estados terminales admiten calificación: finalizado (3),
// cancelado (4) y con error (5).
export const isRateableProcess = (process: ContractIAImportProcess | null): boolean =>
	!!process && (process.status === 3 || process.status === 4 || process.status === 5);

export const isRatedProcess = (process: ContractIAImportProcess | null): boolean =>
	!!process && (process.isRated === true || (process.rating ?? 0) > 0);

// La escala llega de la API; si todavía no llegó (o falló), el selector se
// arma con los cinco puntos sin etiqueta para no bloquear el feedback.
export const buildScale = (
	scale: ImportFeedbackRatingScaleItem[]
): ImportFeedbackRatingScaleItem[] => {
	if (scale && scale.length > 0) {
		return [...scale].sort((a, b) => a.rating - b.rating);
	}
	return [1, 2, 3, 4, 5].map(rating => ({ rating } as ImportFeedbackRatingScaleItem));
};

export const formatFeedbackDate = (raw?: Date | string | null): string | null => {
	if (!raw) return null;
	const date = new Date(raw as string);
	if (isNaN(date.getTime())) return null;
	return date.toLocaleString(undefined, {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
	});
};
